export const INPUT_TYPES = {
    NUMBER: 'NUMBER',
    BOOLEAN: 'BOOLEAN',
    OPTIONS: 'OPTIONS',
    TEXT: 'TEXT',
    COLOR_PICKER: 'COLOR_PICKER',
    FONT_PICKER: 'FONT_PICKER',
    BUTTON: 'BUTTON',
    MULTISELECT: 'MULTISELECT',
    MULTIREPEAT: 'MULTIREPEAT',
    TRANSFORM: 'TRANSFORM',
};
//# sourceMappingURL=constants.js.map